"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryTemplate = void 0;
var qs = require("qs");
var deliveryTemplateGroupsUrl = '/delivery/template-groups';
var deliveryTemplatesUrl = '/delivery/templates';
var Qs = require('qs');
exports.deliveryTemplate = function (axios) {
    return {
        getDeliveryTemplateGroups: function (getDeliveryTemplateGroupsRequest) {
            return axios.get(deliveryTemplateGroupsUrl, getDeliveryTemplateGroupsRequest);
        },
        postDeliveryTemplateGroups: function (postDeliveryTemplateGroupsRequest) {
            return axios.post(deliveryTemplateGroupsUrl, postDeliveryTemplateGroupsRequest.data);
        },
        getDeliveryTemplates: function (getDeliveryTemplatesRequest) {
            return axios.get(deliveryTemplatesUrl, getDeliveryTemplatesRequest);
        },
        getDeliveryTemplateByNo: function (getDeliveryTemplateByNoRequest) {
            return axios.get(deliveryTemplatesUrl + "/" + getDeliveryTemplateByNoRequest.params.templateNo, getDeliveryTemplateByNoRequest);
        },
        postDeliveryTemplates: function (postDeliveryTemplatesRequest) {
            return axios.post(deliveryTemplatesUrl, postDeliveryTemplatesRequest.data);
        },
        getDeliveryTemplateGroupsByGroupNo: function (getDeliveryTemplateGroupsByGroupNoRequest) {
            var url = deliveryTemplateGroupsUrl + "/" + getDeliveryTemplateGroupsByGroupNoRequest.params.templateGroupNo;
            return axios.get(url, getDeliveryTemplateGroupsByGroupNoRequest);
        },
        putDeliveryTemplateGroupsByGroupNo: function (putDeliveryTemplateGroupsByGroupNoRequest) {
            var url = deliveryTemplateGroupsUrl + "/" + putDeliveryTemplateGroupsByGroupNoRequest.params.templateGroupNo;
            return axios.put(url, putDeliveryTemplateGroupsByGroupNoRequest.data);
        },
        deleteDeliveryTemplateGroupsByGroupNo: function (deleteDeliveryTemplateGroupsByGroupNoRequest) {
            var url = deliveryTemplateGroupsUrl + "/" + deleteDeliveryTemplateGroupsByGroupNoRequest.params.templateGroupNo;
            return axios.delete(url, deleteDeliveryTemplateGroupsByGroupNoRequest);
        },
        putDeliveryTemplateGroupsByGroupNoDisplayOrder: function (putDeliveryTemplateGroupsByGroupNoDisplayOrderRequest) {
            var url = deliveryTemplateGroupsUrl + "/" + putDeliveryTemplateGroupsByGroupNoDisplayOrderRequest.params.templateGroupNo + "/display-order";
            var data = Qs.stringify(putDeliveryTemplateGroupsByGroupNoDisplayOrderRequest.params);
            return axios.put(url + '?' + data);
        },
        getDeliveryCompanies: function (getDeliveryCompaniesRequest) {
            return axios.get('/delivery/companies', getDeliveryCompaniesRequest);
        },
        getDeliveryTemplateCheckUsing: function (getDeliveryTemplateCheckUsingRequest) {
            var url = "/delivery/templates/" + getDeliveryTemplateCheckUsingRequest.params.templateNo + "/check-using";
            return axios.get(url, getDeliveryTemplateCheckUsingRequest);
        },
        getDeliveryTemplateSingle: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/delivery/template-groups/single?" + query);
        },
        postDeliveryTemplateSingle: function (request) {
            return axios.post('/delivery/template-groups/single', request.data);
        },
        putDeliveryTemplateSingle: function (request) {
            return axios.put('/delivery/template-groups/single', request.data);
        }
    };
};
